__turbopack_context__.v({
  "fade-in": "LinkCloud-module-scss-module__u34BPW__fade-in",
  "item": "LinkCloud-module-scss-module__u34BPW__item",
  "list": "LinkCloud-module-scss-module__u34BPW__list",
  "no-transform": "LinkCloud-module-scss-module__u34BPW__no-transform",
  "rotate": "LinkCloud-module-scss-module__u34BPW__rotate",
});
